import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const scroll = keyframes`
  0% { transform: translateX(0); } /* Start with text in view */
  100% { transform: translateX(-100%); }
`;

const BannerWrapper = styled.div`
  width: 100%;
  background: linear-gradient(90deg, #ffd847 0%, #ffea70 50%, #ffd847 100%);
  overflow: hidden;
  padding: 4px 0;
  
  height: 34px;


@media (max-width: 768px) {
    margin-top: -50px;
  }
  
`;

const BannerTrack = styled.div`
  display: inline-block;
  width: 100%;
  
  white-space: nowrap;
  animation: ${scroll} 15s linear infinite;
`;

const BannerText = styled(Link)`
  font-weight: 700;
  color: #0b3d73;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  text-decoration: none;
  margin-right: 10rem;
  letter-spacing: 0.01em;

  &:hover {
    text-decoration: underline;
  }
`;

function TradeBanner() {
  return (
    <BannerWrapper>
      <BannerTrack>
        <BannerText to="/tradesignup">Tradespeople Click Here to Sign Up Today — Grow your business and get more leads for less!</BannerText>
        <BannerText to="/tradesignup">Tradespeople Click Here to Sign Up Today — Grow your business and get more leads for less!</BannerText>
        <BannerText to="/tradesignup">Tradespeople Click Here to Sign Up Today — Grow your business and get more leads for less!</BannerText>
        <BannerText to="/tradesignup">Tradespeople Click Here to Sign Up Today — Grow your business and get more leads for less!</BannerText>
        <BannerText to="/tradesignup">Tradespeople Click Here to Sign Up Today — Grow your business and get more leads for less!</BannerText>
      </BannerTrack>
    </BannerWrapper>
  );
}

export default TradeBanner;
